// src/localeNames.ts
var ANCHOR_YEAR = 2023;
var cache = /* @__PURE__ */ new Map();
var memo = (key, factory) => {
  const hit = cache.get(key);
  if (hit) return hit;
  const value = factory();
  cache.set(key, value);
  return value;
};
var getMonthNames = (locale, style = "long") => memo(`m:${locale}:${style}`, () => {
  const fmt = new Intl.DateTimeFormat(locale, { month: style, timeZone: "UTC" });
  return Array.from(
    { length: 12 },
    (_, month) => fmt.format(new Date(Date.UTC(ANCHOR_YEAR, month, 1)))
  );
});
var getWeekdayNames = (locale, style = "long", weekStartsOn = 0) => memo(`w:${locale}:${style}:${weekStartsOn}`, () => {
  const fmt = new Intl.DateTimeFormat(locale, { weekday: style, timeZone: "UTC" });
  return Array.from(
    { length: 7 },
    (_, day) => fmt.format(new Date(Date.UTC(ANCHOR_YEAR, 0, 1 + weekStartsOn + day)))
  );
});

export {
  getMonthNames,
  getWeekdayNames
};
